import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography,
    RadioGroup, Radio, FormControlLabel, FormControl
} from "@mui/material";

export default function CancelAppointmentDialog({ open, onClose, onConfirm, appointment }) {
    const [cancellationReason, setCancellationReason] = React.useState('');

    const reasons = [
        'Need to reschedule',
        'Symptoms improved',
        'Cost/insurance concerns',
        'Scheduling conflict',
    ];

    const handleClose = () => {
        setCancellationReason('');
        onClose();
    };

    const handleConfirm = () => {
        onConfirm(cancellationReason);
        setCancellationReason('');
    };

    React.useEffect(() => {
        if (!open) {
            setCancellationReason('');
        }
    }, [open]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="cancel-dialog-title"
            aria-describedby="cancel-dialog-description"
            PaperProps={{
                sx: {
                    backgroundColor: 'white',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    minWidth: '300px',
                }
            }}
        >
            <DialogTitle 
                id="cancel-dialog-title"
                sx={{
                    pb: 1.5,
                    pt: 3,
                    px: 3,
                }}
            >
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 700,
                        color: '#333',
                        fontSize: '1.25rem',
                    }}
                >
                    Cancel Appointment
                </Typography>
            </DialogTitle>
            <DialogContent sx={{ px: 3, pb: 2 }}>
                <DialogContentText 
                    id="cancel-dialog-description" 
                    sx={{ 
                        color: '#666',
                        fontSize: '0.95rem',
                        lineHeight: 1.5,
                        mb: 2,
                    }}
                >
                    We understand plans change. Please let us know why you're canceling:
                </DialogContentText>
                <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                        value={cancellationReason}
                        onChange={(e) => setCancellationReason(e.target.value)}
                        sx={{ gap: 0.25 }}
                    >
                        {reasons.map((reason) => (
                            <FormControlLabel
                                key={reason}
                                value={reason}
                                control={<Radio sx={{ color: '#666', '&.Mui-checked': { color: '#E54F42' }, py: 0.25 }} />}
                                label={
                                    <Typography sx={{ color: '#666', fontSize: '0.9rem' }}>
                                        {reason}
                                    </Typography>
                                }
                                sx={{ m: 0 }}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3, pt: 1, justifyContent: 'flex-end', gap: 1.5 }}>
                <Button
                    onClick={handleClose}
                    sx={{
                        backgroundColor: 'white',
                        color: '#666',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        py: 0.75,
                        px: 2,
                        fontSize: '0.9rem',
                        minWidth: 'auto',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                            borderColor: '#bbb',
                        },
                    }}
                >
                    Keep Appt.
                </Button>
                <Button
                    onClick={handleConfirm}
                    disabled={!cancellationReason}
                    sx={{
                        backgroundColor: '#E54F42',
                        color: 'white',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        py: 0.75,
                        px: 2,
                        fontSize: '0.9rem',
                        minWidth: 'auto',
                        '&:hover': {
                            backgroundColor: '#d43e32',
                        },
                        '&:disabled': {
                            backgroundColor: '#ccc',
                            color: '#999',
                        },
                    }}
                >
                    Cancel Appt.
                </Button>
            </DialogActions>
        </Dialog>
    );
}
